
export const loginSuccess = (type,user) => ({
  type:type,// 'LOGIN_SUCCESS',
  payload: user,
});

export const logout = (type) => ({
  type: type, //'LOGOUT',
});

export const setHeaderName = (type,name) => ({
  type: type,
  payload: name,
});

export const setSelectedIndex = (type,label)=>({
  type: type,
  payload: label,
})
